import { render } from "./chart.vue?vue&type=template&id=567a021a&scoped=true&ts=true"
import script from "./chart.vue?vue&type=script&lang=ts&config=true"
export * from "./chart.vue?vue&type=script&lang=ts&config=true"

import "./chart.vue?vue&type=style&index=0&id=567a021a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567a021a"]])

export default __exports__